import { ActionTree } from 'vuex';
import { NotificationState } from './types';
import { RootState } from '@/store/types';
import { INIT_NOTIFICATION_MUTATION, HIDE_NOTIFICATION_MUTATION } from './mutationTypes';

const SHOW_TIME = 5000;

export const actions: ActionTree<NotificationState, RootState> = {
  initNotification({ commit }, payload: NotificationState & { timeout?: number }) {
    commit(INIT_NOTIFICATION_MUTATION, payload);
    setTimeout(() => {
      commit(HIDE_NOTIFICATION_MUTATION);
    }, payload.timeout ?? SHOW_TIME);
  },

  socket_notification({ dispatch }, data: { type: string; text: string; timeout?: number }) {
    dispatch('initNotification', { message: data.text, mode: data.type, timeout: data.timeout });
  },

  hideNotification({ commit }) {
    commit(HIDE_NOTIFICATION_MUTATION);
  },

  initNotificationError({ dispatch }, message: string) {
    dispatch('initNotification', { message, mode: 'error' });
  },

  initNotificationSuccess({ dispatch }, message: string) {
    dispatch('initNotification', { message, mode: 'success' });
  },

  initNotificationWarning({ dispatch }, message: string) {
    dispatch('initNotification', { message, mode: 'warning' });
  },

  initNotificationDialog({ commit }, message: string) {
    commit(INIT_NOTIFICATION_MUTATION, { dialogMessage: message });
  },
};
